import React from 'react';
import Stats from './Stats';

const Dashboard = ({ stats, onRefresh }) => {
  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">لوحة التحكم الرئيسية</h2>
          <button className="btn btn-primary btn-sm" onClick={onRefresh}>
            🔄 تحديث
          </button>
        </div>
      </div>
      <Stats stats={stats} onRefresh={onRefresh} />
    </div>
  );
};

export default Dashboard;
